/* global angular */

angular.module('gc.recaptcha', [])
.service('RecaptchaService', [
'$http',
'API_URL',
function ($http, API_URL) {
  'use strict';
  

  this.getCode = function() {
    return $http({
      method: 'GET',
      url: API_URL + '/captcha/'
    });
  };

  this.validate = function(data) {
    return $http({
      method: 'POST',
      url: API_URL + '/captcha/',
      data,
    });
  };
  
}
]);
